/* eslint-env jquery */
/* eslint-disable func-names */
/**
 * Training Info Component
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'training-info';

class TrainingInfo extends Component {

    /**
     * Initialize Component
     */
    init() {

        // Add sort-value attr to ul's (from sort-date attr in courseDate li)
        $('.course-detail[data-course-date]').each(
            function() {
                const sortVal = Date.parse($(this).data('course-date').substring(0, 16));
                $(this).parent().attr('data-sort-value', sortVal);
            }
        );

        // Order ul's by sort-value
        const courseList = $('.upcoming-courses');
        const courses = $('.course-instance[data-sort-value]');
        courses.sort((a, b) => $(a).data('sort-value') - $(b).data('sort-value'));
        courses.prependTo(courseList);

        // Exclude past dates
        const todaysDate = new Date();
        $('.course-instance').filter(function() {
            return $(this).data('sort-value') < Date.parse(todaysDate);
        }).hide();
    }
}

registerComponent(`.${componentName}`, TrainingInfo);
